import RotatingCanadianNews from "../CanadianNews/CanadianNews";
import RotatingEventsCard from "../CanadianNews/RotatingEventsCard";
import RotatingMarketCard from "../CanadianNews/RotatingMarketCard";
import Following from "./Following";

import {
  IonContent,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
} from "@ionic/react";
import {
  calendarOutline,
  carOutline,
  cartOutline,
  flameOutline,
  locationOutline,
  peopleOutline,
  schoolOutline,
} from "ionicons/icons";
import Feed from "../../components/Feed/Feed";
import {
  getAllPosts,
  getAllVideos,
  getHashtagPosts,
  getPollPosts,
  getRacePosts,
  getTrendingPosts,
} from "../../redux/actions/postActions";

import { useState } from "react";
import { Redirect, Route, useLocation } from "react-router-dom";
import "./home.css";
import { t } from "i18next";
import { Helmet } from "react-helmet-async";

function Polls() {
  return (
    <Feed
      postsSelector={(state) => state.post.pollPosts}
      fetchAction={getPollPosts}
    />
  );
}

function Race() {
  return (
    <Feed
      postsSelector={(state) => state.post.racePosts}
      fetchAction={getRacePosts}
    />
  );
}

export const Latest = () => {
  return (
    <Feed
      showNewUsers
      postsSelector={(state) => state.post.allPosts}
      fetchAction={getAllPosts}
    />
  );
};
export const Trending = () => {
  return (
    <Feed
      postsSelector={(state) => state.post.trendingPosts}
      fetchAction={getTrendingPosts}
    />
  );
};
export const Study = () => {
  return (
    <Feed
      postsSelector={(state) => state.post.hashtagPosts["quiz"]}
      fetchAction={getHashtagPosts}
      fetchActionProps={{ tag: "quiz" }}
    />
  );
};
export const Market = () => {
  return (
    <Feed
      postsSelector={(state) => state.post.hashtagPosts["market"]}
      fetchAction={getHashtagPosts}
      fetchActionProps={{ tag: "market" }}
    />
  );
};
export const Rides = () => {
  return (
    <Feed
      postsSelector={(state) => state.post.hashtagPosts["ride"]}
      fetchAction={getHashtagPosts}
      fetchActionProps={{ tag: "ride" }}
    />
  );
};

export const Videos = () => {
  return (
    <Feed
      postsSelector={(state) => state.post.allVideos}
      fetchAction={getAllVideos}
      fetchActionProps={{}}
    />
  );
};

export const News = () => {
  const [activeTab, setActiveTab] = useState("news");

  return (
    <IonContent>
      {/* Custom Red Toggle Container */}
      <div
        style={{
          display: "flex",
          backgroundColor: "#e3001b", // Adjust to your exact red
          borderRadius: "12px",
          padding: "6px",
          margin: "8px 16px 16px 16px",
          gap: "4px",
          position: "sticky",
          top: "8px",
          zIndex: "10",
        }}
      >
        {/* News Button */}
        <div
          onClick={() => setActiveTab("news")}
          style={{
            flex: 1,
            textAlign: "center",
            padding: "10px 0",
            borderRadius: "8px",
            fontWeight: "bold",
            cursor: "pointer",
            transition: "all 0.3s ease",
            backgroundColor: activeTab === "news" ? "#ffffff" : "transparent",
            color: activeTab === "news" ? "#e3001b" : "#ffffff",
          }}
        >
          NEWS
        </div>

        {/* Events Button */}
        <div
          onClick={() => setActiveTab("events")}
          style={{
            flex: 1,
            textAlign: "center",
            padding: "10px 0",
            borderRadius: "8px",
            fontWeight: "bold",
            cursor: "pointer",
            transition: "all 0.3s ease",
            backgroundColor: activeTab === "events" ? "#ffffff" : "transparent",
            color: activeTab === "events" ? "#e3001b" : "#ffffff",
          }}
        >
          EVENTS
        </div>

        {/* Market Button */}
        <div
          onClick={() => setActiveTab("market")}
          style={{
            flex: 1,
            textAlign: "center",
            padding: "10px 0",
            borderRadius: "8px",
            fontWeight: "bold",
            cursor: "pointer",
            transition: "all 0.3s ease",
            backgroundColor: activeTab === "market" ? "#ffffff" : "transparent",
            color: activeTab === "market" ? "#e3001b" : "#ffffff",
          }}
        >
          TSX
        </div>
      </div>

      {/* The Tab Content */}
      <div style={{ padding: "0 16px" }}>
        {activeTab === "news" && <RotatingCanadianNews />}
        {activeTab === "events" && <RotatingEventsCard />}
        {activeTab === "market" && <RotatingMarketCard />}
      </div>
    </IonContent>
  );
};
const HomeTabs = () => {
  const location = useLocation();
  const [discoverSubtab] = useState("latest");

  return (
    <IonTabs>
      <IonRouterOutlet>
        {/* Redirect base path to discover */}
        <Route
          exact
          path="/home"
          render={() => <Redirect to={`/home/discover`} />}
        />

        <Route
          path={`/home/discover`}
          render={() => (
            <IonContent className="no-top-gap" fullscreen>
              {/* Removed the empty IonHeader to prevent iOS from reserving space above content.
                  If you re-enable the segment, wrap it in a header again. */}
              {discoverSubtab === "latest" && <Latest />}
              {discoverSubtab === "trending" && <Trending />}
              {discoverSubtab === "study" && <Study />}
              {discoverSubtab === "market" && <Market />}
              {discoverSubtab === "rides" && <Rides />}
              {discoverSubtab === "polls" && <Polls />}
              {discoverSubtab === "race" && <Race />}
              {discoverSubtab === "videos" && <Videos />}
            </IonContent>
          )}
        />

        {/* Following */}
        <Route path={`/home/following`} component={Following} />

        {/* Local */}
        <Route path={`/home/local`} component={News} />
      </IonRouterOutlet>

      {/* ===== Main Tabs ===== */}
      <IonTabBar slot="top" className="main-tabs">
        <IonTabButton
          // className="poetsen"
          tab="discover"
          href={`/home/discover`}
          selected={location.pathname.startsWith("/home/discover")}
        >
          {/* <IonIcon icon={compassOutline} /> */}
          <IonLabel className="padding-bottom">{t("discover")}</IonLabel>
        </IonTabButton>

        <IonTabButton
          tab="following"
          // className="poetsen"
          href={`/home/following`}
          selected={location.pathname.startsWith("/home/following")}
        >
          {/* <IonIcon icon={peopleOutline} /> */}
          <IonLabel className="padding-bottom">{t("following")}</IonLabel>
        </IonTabButton>

        <IonTabButton
          tab="local"
          // className="poetsen"
          href={`/home/local`}
          selected={location.pathname.startsWith("/home/local")}
        >
          {/* <IonIcon icon={locationOutline} /> */}
          <IonLabel className="padding-bottom">Canada</IonLabel>
        </IonTabButton>
      </IonTabBar>
    </IonTabs>
  );
};

const Home = () => {
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <HomeTabs
        tabs={[
          {
            label: (
              <>
                <IonIcon icon={calendarOutline} />
                <br />
                New
              </>
            ),
            path: "latest",
            Component: Latest,
          },
          {
            label: (
              <>
                <IonIcon icon={flameOutline} />
                <br />
                Trending
              </>
            ),
            path: "trending",
            Component: Trending,
          },
          {
            label: (
              <>
                <IonIcon icon={schoolOutline} />
                <br />
                Study
              </>
            ),
            path: "study",
            Component: Study,
          },
          {
            label: (
              <>
                <IonIcon icon={cartOutline} />
                <br />
                Market
              </>
            ),
            path: "market",
            Component: Market,
          },
          {
            label: (
              <>
                <IonIcon icon={carOutline} />
                <br />
                Rides
              </>
            ),
            path: "rides",
            Component: Rides,
          },
          {
            label: (
              <>
                <IonIcon icon={peopleOutline} />
                <br />
                Following
              </>
            ),
            path: "following",
            Component: Following,
          },
          {
            label: (
              <>
                <IonIcon icon={locationOutline} />
                <br />
                Local
              </>
            ),
            path: "local",
            Component: News,
          },
        ]}
      />
    </>
  );
};
export default Home;
